/* system-cms-prefix start */
const prefix = '/cmsmanager'
/* system-cms-prefix change const prefix = '/cmsadmin' system-cms-prefix change */
/* system-cms-prefix end */

export default {
  // 评论管理列表
  interactUsercommentList: `${prefix}/usercomment/page`,
  // 修改审核状态
  interactUsercommentStatus: `${prefix}/usercomment/status`,
  // 回复信息
  interactUsercommentReply: `${prefix}/usercomment/reply`,
  // 删除评论
  interactUsercomment: `${prefix}/usercomment`,
  // 新增禁止
  interactUsercommentPlusStop: `${prefix}/usercomment/plus/stop`,
  // 取消禁止
  interactUsercommentCancelStop: `${prefix}/usercomment/cancel/stop`,
  // 推荐编辑
  interactUsercommentTop: `${prefix}/usercomment/top`,
  // 查看列表数量
  interactUsercommentCount: `${prefix}/usercomment/count`,
  // 特定条件分页列表
  interactUsercommentSpecific: `${prefix}/usercomment/specific/page`,
  // 黑名单列表
  sysblacklistPage: `${prefix}/sysblacklist/page`,
  // 删除单个黑名单
  sysblacklist: `${prefix}/sysblacklist`,

  // 举报列表
  usercommentReportPage: `${prefix}/usercomment/report/page`,
  // 清除举报状态
  usercommentReport: `${prefix}/usercomment/report`,

  // 采集 ////////////////////////////////////////////////////
  // 获取栏目和APPID
  collectGetId: `${prefix}/collect/getId`,
  collectConsume: `${prefix}/collect/consume`,
  collectConsumeByIds: `${prefix}/collect/consumeByIds`,

  // 友情链接////////////////////////////////////////////////////////
  // 链接类别表格
  linkTypesPage: `${prefix}/linkTypes/page`,
  // 链接类别增删改查
  linkTypes: `${prefix}/linkTypes`,
  // 链接类别检查类别名是否唯一
  linkTypesTypeName: `${prefix}/linkTypes/typeName/unique`,
  // 友情链接列表
  linkTsPage: `${prefix}/links/page`,
  // 友情链接增删改查
  links: `${prefix}/links`,
  // 友情链接启用
  linksEnable: `${prefix}/links/enable`,
  // 友情链接取消启用
  linksunEnable: `${prefix}/links/unEnable`,
  // 友情链接列表选择列表
  linkTypesList: `${prefix}/linkTypes/list`,
  // 友情链接列表选择列表
  linksMove: `${prefix}/links/move`,
  // 友情链接拖动
  linksSort: `${prefix}/links/sort`,
  // 友情链接分类拖动
  linksTypesSort: `${prefix}/linkTypes/sort`,
  // 投票调查-分页列表
  questionnairePage: `${prefix}/questionnaire/page`,
  // 投票调查-增删
  questionnaire: `${prefix}/questionnaire`,
  // 投票调查-提交审核
  questionnaireSubmit: `${prefix}/questionnaire/submit`,
  // 投票调查-审核通过
  questionnaireReviewOk: `${prefix}/questionnaire/review/ok`,
  // 投票调查-审核不通过
  questionnaireReviewFail: `${prefix}/questionnaire/review/fail `,
  // 投票调查-发布
  questionnaireRelease: `${prefix}/questionnaire/release `,
  // 投票调查-暂停
  questionnairePause: `${prefix}/questionnaire/pause`,
  // 投票调查-预览
  questionnairePreview: `${prefix}/questionnaire/preview`,
  // 投票调查-撤回
  questionnaireWithdraw: `${prefix}/questionnaire/withdraw`,
  // 投票调查-复制
  questionnaireCopy: `${prefix}/questionnaire/copy`,
  // 投票调查-问卷链接
  questionnaireLink: `${prefix}/questionnaire/link`,
  // 投票调查-下载二维码
  questionnaireQrcode: `${prefix}/questionnaire/qrcode`,
  // 投票调查-待办列表
  taskQuestionnaireToDeal: `${prefix}/task/questionnaire/toDeal`,
  // 投票调查-审核
  taskQuestionnaireAudit: `${prefix}/task/questionnaire/audit`,
  // 投票调查-已办列表
  taskQuestionnaireHandle: `${prefix}/task/questionnaire/handle`,
  // 投票调查-逾期未办
  taskQuestionnaireOverDue: `${prefix}/task/questionnaire/overDue`,
  // 投票调查-撤回(有工作流)
  taskQuestionnaireRevoke: `${prefix}/task/questionnaire/revoke`,
  // 投票调查-判断是否配置工作流
  questionnaireWorkflow: `${prefix}/questionnaire/workflow`,
  // 投票调查-统计-按用户
  questionnaireAnswerPage: `${prefix}/questionnaireAnswer/page`,
  // 投票调查-统计-按用户-删除
  questionnaireAnswer: `${prefix}/questionnaireAnswer`,
  // 投票调查-统计-按用户-有效
  questionnaireAnswerValid: `${prefix}/questionnaireAnswer/valid`,
  // 投票调查-统计-按用户-无效
  questionnaireAnswerInvalid: `${prefix}/questionnaireAnswer/invalid`,
  // 投票调查-统计-按用户-导出
  questionnaireAnswerExport: `${prefix}/questionnaireAnswer/export`,
  // 投票调查-统计-按题目-导出
  questionnaireAnswerSubjectExport: `${prefix}/questionnaireAnswer/subject/export`,
  // 投票调查-统计-问卷统计
  questionnaireFind: `${prefix}/questionnaire/find`,
  // 投票调查-统计-按题目分页列表
  questionnaireAnswerSubjectPage: `${prefix}/questionnaireAnswer/subject/page`,
  // 投票调查-统计-题目分类-饼图
  questionnaireFindSubjectPieChart: `${prefix}/questionnaireAnswer/subject/pieChart`,
  // 投票调查-统计-按题目列表（左侧）
  questionnaireAnswerSubjectList: `${prefix}/questionnaireAnswer/subject/list`,
  // 投票调查-统计-设备分析-饼图
  questionnaireAnswerChartDevice: `${prefix}/questionnaireAnswer/chart/device`,
  // 投票调查-统计-来源分析-地图
  questionnaireAnswerChartMap: `${prefix}/questionnaireAnswer/chart/map`,
  // 投票调查-统计-趋势分析-折线图
  questionnaireAnswerChartTrend: `${prefix}/questionnaireAnswer/chart/trend`,
  // 投票调查-图片列表
  questionnairePic: `${prefix}/questionnaire/pic`,
  // 智能表单-类型列表
  smartFormTypeList: `${prefix}/formType/list`,
  // 智能表单-新建类型列表
  smartFormType: `${prefix}/formType`,
  // 智能表单-检测分组名称是否可用
  smartFormTypeUnique: `${prefix}/formType/unique`,
  // 智能表单-表单列表
  smartSmartFormGetPage: `${prefix}/smartForm/getPage`,
  // 智能表单-图片列表
  smartionnairePic: `${prefix}/resourceSpaceDatas/pic`,
  // 智能表单-表单列表
  smartFormDataList: `${prefix}/smartFormData/getPage`,
  // 智能表单-统计-图表
  smartFormGraph: `${prefix}/smartForm/statistic/groupByField/`,
  // 智能表单-统计-导出
  smartFormDataExport: `${prefix}/smartFormData/export`,
  // 智能表单-统计-item详情
  smartFormDataDetail: `${prefix}/smartFormData`,
  // 智能表单-表单详情
  smartFormDetail: `${prefix}/smartForm`,
  // 智能表单-表单新增，删除，详情
  smartForm: `${prefix}/smartForm`,
  // 智能表单-表单分组保存
  simpleUpdate: `${prefix}/smartForm/simpleUpdate`,
  // 智能表单-表单重名验证
  smartFormUnique: `${prefix}/smartForm/unique`,
  // 智能表单-表单发布
  smartFormPublish: `${prefix}/smartForm/publish`,
  // 智能表单-自定义表单编辑字段
  smartFormUpdateFields: `${prefix}/smartForm/updateFields`,
  // 智能表单-数据列表-复制表单
  smartFormCopy: `${prefix}/smartForm/copy`,
  // 智能表单-数据列表-清空表单数据
  smartFormClearData: `${prefix}/smartForm/clearData`,
  // 智能表单-统计-设备统计
  smartFormStatisticDevice: `${prefix}/smartForm/statistic/device`,
  // 智能表单-统计-地区统计
  smartFormStatisticProvince: `${prefix}/smartForm/statistic/province`,
  // 智能表单-统计-趋势统计
  smartFormStatisticTrend: `${prefix}/smartForm/statistic/trend`,

  // 领导信箱////////////////////////////////////////////////////////
  // 领导信箱-表单列表
  letterFormGetPage: `${prefix}/letterForm/getPage`,
  // 领导信箱-表单新增，删除，详情
  letterForm: `${prefix}/letterForm`,
  // 领导信箱-表单重名验证
  letterFormUnique: `${prefix}/letterForm/unique`,
  // 领导信箱-数据列表-复制表单
  letterFormCopy: `${prefix}/letterForm/copy`,
  // 领导信箱-信箱管理-信箱分类列表
  letterBoxTypeList: `${prefix}/letterBoxType/list`,
  // 领导信箱-信箱类型新增，删除，详情
  letterBoxType: `${prefix}/letterBoxType`,
  // 领导信箱-信箱类型名称是否可用
  letterBoxTypeUnique: `${prefix}/letterBoxType/unique`,
  // 领导信箱-信箱列表
  letterBoxGetPage: `${prefix}/letterBox/getPage`,
  // 领导信箱-信箱新增、删除、详情
  letterBox: `${prefix}/letterBox`,
  // 领导信箱-信箱名称是否可用
  letterBoxUnique: `${prefix}/letterBox/unique`,
  // 领导信箱-我的信箱
  letterBoxOwner: `${prefix}/letterBox/owner/list`,
  // 领导信箱-信件类型分页列表
  letterTypeGetPage: `${prefix}/letterType/getPage`,
  // 领导信箱-信件类型列表
  letterTypeGetList: `${prefix}/letterType/list`,
  // 领导信箱-信件类型新增、删除、详情
  letterType: `${prefix}/letterType`,
  // 领导信箱-信件类型名称是否可用
  letterTypeUnique: `${prefix}/letterType/unique`,
  // 信件分页
  mailboxLetterPage: `${prefix}/letter/page`,
  // 回复信件
  mailboxLetterReply: `${prefix}/letter/reply`,
  // 信件办结
  mailboxLetterFinish: `${prefix}/letter/finish`,
  // 信件删除
  letter: `${prefix}/letter`,
  // 来信选登
  letterDigest: `${prefix}/letter/digest`,
  // 取消选登
  letterCancleDigest: `${prefix}/letter/cancleDigest`,
  // 你问我答////////////////////////////////////////////////////////
  // 你问我答-问题列表
  questionGetPage: `${prefix}/myQuestion/page`,
  // 你问我答-问题新增、删除、详情
  questionDelete: `${prefix}/myQuestion`,
  // 你问我答-开启评论
  questionOpen: `${prefix}/myQuestion/open`,
  // 你问我答-关闭评论
  questionClose: `${prefix}/myQuestion/close`,
  // 你问我答-回答列表
  answerPageByQuestion: `${prefix}/myAnswer/pageByQueId`,
  // 你问我答-回答删除
  answers: `${prefix}/myAnswer`,
  // 你问我答-官方回答新增
  answersAdd: `${prefix}/myAnswer/add`,
  // 你问我答-官方回答修改
  answersEdit: `${prefix}/myAnswer/edit`,
}
